<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{title}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('users.header')}}</label>
              <el-form-item prop="users">
                <base-el-select ref="usersSelect" class="w-full" :options="users" v-model="form.users" multiple filterable :disabled="isLoadingSelect" @visible-change="onExpand" @change="onChangeInput" />
              </el-form-item>
            </div>
          </div>

          <div class="lg:mb-2 ">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{finalLabelOrigen}}</label>
            <el-radio-group v-model="form.radioOrigen" class="flex flex-col md:inline-block">
              <el-radio-button :label="0">{{ $t('app.all') }}</el-radio-button>
              <el-radio-button class="border-l-2 dark:border-darkblue-300" :label="1">{{ $tc('groups.temporal', 2) }}</el-radio-button>
              <el-radio-button class="border-l-2 dark:border-darkblue-300" :label="2">{{ $tc('groups.permanent', 2) }}</el-radio-button>
            </el-radio-group>
          </div>
          
          <div class="lg:mb-2">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{finalLabelDestino}}</label>
            <el-radio-group v-model="form.radioDestino" class="flex flex-col md:inline-block">
              <el-radio-button :label="0" v-popover:popovermantener>{{ $t('groups.keep_origin_state') }}</el-radio-button>
              <el-popover
                ref="popovermantener"
                placement="left"
                width="300"
                :value="form.radioDestino === 0 && form.radioOrigen !== 1"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                trigger="manual"
                >
                <div class="break-normal">{{ $t('groups.override_temporal_as_permanent') }}</div>
              </el-popover>
              <el-radio-button class="border-l-2 dark:border-darkblue-300" :label="1">{{ $tc('groups.temporal', 2) }}</el-radio-button>
              <el-radio-button 
                class="border-l-2 dark:border-darkblue-300" 
                :label="2"
                v-popover:popoverpermanentes
                >
                {{ $tc('groups.permanent', 2) }}
              </el-radio-button>
              <el-popover
                ref="popoverpermanentes"
                placement="right"
                width="300"
                :value="form.radioDestino === 2"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                trigger="manual"
                >
                <div class="break-normal">{{ $t('groups.override_as_permanent') }}</div>
              </el-popover>
            </el-radio-group>
          </div>

        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
          class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')"
          @click="$refs.usersSelect.selectAll()"
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
          class="w-full"
          @click="$refs.usersSelect.unselectAll()"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getAllUsers } from '@/services/configurations/getAllUsers'
import { i18n } from '@/i18n'

export default
{
  name: 'user-link-users-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idUsuario: {
      type: [Number, String],
      default: -1
    },
    title: {
      type: String,
      default: '',
    },
    labelOrigen: {
      type: String,
      default: ''
    },
    labelDestino: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        users: [],
        radioOrigen: 2,
        radioDestino: 1,
      },
      users: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getAllUsers({ idUsuario: this.idUsuario })
    if (data.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
    } else {
      data.respuesta.forEach(row => {
        this.users.push({ value: row.IdUsuario, label: row.Usuario })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    isEmptyList: function () {
      return this.users === undefined || this.users === null || this.users.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.users.length === this.form.users.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        const maxHeight = 400
        const nextHeight = this.heightSelect + this.heightInput + 30
        const minHeigth = this.$refs.containerSelect?.clientHeight ?? 0
        const heightCalc = Math.min(Math.max(nextHeight, minHeigth), maxHeight)
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    finalLabelOrigen: function () {
      return this.labelOrigen || i18n.t('app.origen')
    },
    finalLabelDestino: function () {
      return this.labelDestino || i18n.t('app.destino')
    },
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          this.heightSelect = document.getElementsByClassName('el-scrollbar')[0]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.users = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form)
      this.form.users = []
    },
  }
}
</script>

<style lang="scss" scoped></style>
